import moment from 'moment-timezone';
import Request from 'files/Request.js';
import User from 'classes/User.js';

class UserAvailabilityClass {

    active = null;
    client_id = null;
    created = null;
    created_by_user_id = null;
    day_of_week = null;
    end_time = null;
    id = null;
    is_recurring = null;
    reason = null;
    specific_date = null;
    start_time = null;
    timezone = null;
    updated = null;
    user = null;
    user_id = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {

        let timezone = props.timezone || moment.tz.guess();
        
        this.active = props.active;
        this.client_id = props.client_id;
        this.created = props.created && moment.utc(props.created).local();
        this.created_by_user_id = props.created_by_user_id;
        this.day_of_week = props.day_of_week;
        this.end_time = props.end_time && moment.tz(props.end_time, 'HH:mm:ss', timezone);
        this.id = props.id;
        this.is_recurring = props.is_recurring;
        this.specific_date = props.specific_date && moment.tz(props.specific_date, 'YYYY-MM-DD', timezone);
        this.start_time = props.start_time && moment.tz(props.start_time, 'HH:mm:ss', timezone);
        this.updated = props.updated && moment.utc(props.updated).local();
        this.user = props.user && User.create(props.user);
        this.user_id = props.user_id;
        return this;
    }
}

export const checkAvailability = async (utils, userID, date, time) => {
    return new Promise(async (resolve, reject) => {
        try {
            let result = await Request.get(utils, '/users/', {
                date: date,
                time: time,
                type: 'check_availability',
                user_id: userID
            });
            resolve(result);
        } catch(e){
            reject(e);
        }
    })
}

const dayOfWeekToText = code => {
    switch(code) {
        case 0:
        return 'Sunday';

        case 1:
        return 'Monday';

        case 2:
        return 'Tuesday';

        case 3:
        return 'Wednesday';

        case 4:
        return 'Thursday';

        case 5:
        return 'Friday';

        case 6:
        return 'Saturday';

        default:
        return 'Unknown';
    }
}

export default {
    new: () => new UserAvailabilityClass(),
    checkAvailability: (utils, userID, date, time) => checkAvailability(utils, userID, date, time),
    create: props => new UserAvailabilityClass().create(props),
    dayOfWeekToText: dayOfWeekToText
};
